<template>
  <div>
    <v-item-group active-class="primary" v-model="selection">
      <v-row>
        <v-col v-for="(item, key) in wpItems" :key="key" cols="12" :md="isResellerSubAccount ? 6 : 4">
          <v-item v-slot="{ active, toggle }" :value="item">
            <v-card class="app-card d-flex align-center" height="100%" @click="toggle">
              <v-card-text class="text-center pa-2 d-flex flex-column justify-space-between h-100" :style="cardActiveStyle(active)">
                <div class="py-4">
                  <v-avatar>
                    <v-img
                      :src="wizardIcon(item)"
                      max-height="60"
                      class="ma-auto"
                      contain
                    />
                  </v-avatar>
                </div>
                <h3>
                  {{ item.name }}
                </h3>
                <h5 v-show="!!item.subtitle">
                  {{ item.subtitle }}
                </h5>
                <gg-btn class="mt-5 mb-2 mx-auto" :color="active ? 'white' : 'primary'" secondary width="max-content">
                  {{ active ? 'Selected' : 'Select' }}
                </gg-btn>
              </v-card-text>
            </v-card>
          </v-item>
        </v-col>
      </v-row>
    </v-item-group>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { cardActiveStyle, wizardIcon } from '@/helpers/wizard'
import { SERVICE_TYPES } from '@/consts/service'

export default {
  name: 'StepOne',
  props: {
    isExtendifyAllowed: {
      type: Boolean,
      default: true,
    }
  },
  data () {
    return {
      selection: '',
      items: [
        {
          key: 'extendify',
          name: 'WordPress + AI',
          subtitle: 'AI-powered WordPress to grow your hosting business.',
        },
        {
          key: 'wordpress',
          name: 'WordPress',
          subtitle: 'Create an amazing website or blog with WordPress.',
        },
        {
          key: 'wpwoocommerce',
          name: 'WordPress + WooCommerce',
          subtitle: 'Build a powerful online store to sell your products or services.',
        },
      ]
    }
  },
  computed: {
    ...mapGetters(['hosting_detail', 'hosting', 'hostingPopulated', 'hosting_error']),
    isResellerSubAccount () {
      return this.hosting.type === SERVICE_TYPES.RESELLER
    },
    wpItems () {
      if (this.isResellerSubAccount) {
        return this.items.toSpliced(0, 1)
      }
      return this.items
    },
  },
  methods: {
    ...mapMutations({
      setPlugins: 'hosting_wp_install/SET_PLUGINS',
      setApp: 'hosting_wp_install/SET_WIZARD_APP',
    }),
    wizardIcon,
    cardActiveStyle,
    nextStep () {
      this.$emit('next-step')
    },
    prevStep () {
      this.$emit('prev-step')
    },
    cancelSelection () {
      this.selection = ''
    }
  },
  watch: {
    selection (val) {
      switch (val?.key) {
        case 'wordpress':
          this.setPlugins(['litespeed-cache'])
          this.setApp('wordpress')
          this.nextStep()
          break
        case 'wpwoocommerce':
          this.setPlugins(['litespeed-cache', 'woocommerce'])
          this.setApp('wpwoocommerce')
          this.nextStep()
          break
        case 'extendify':
          this.setPlugins(['litespeed-cache'])
          this.setApp('extendify')
          this.nextStep()
          break
        default:
          this.prevStep()
      }
    }
  }
}
</script>
